import './Gatekeeper.css';
import React from 'react';
import { Card } from '../../components/Card/Card';
import { Stack } from '../../components/Stack/Stack';
import logo from '../../assets/ks_logo_vector.svg';
import GlobalProps from '../../components/globalProps';

export function Gatekeeper({ children }: GlobalProps): JSX.Element {
  return (
    <div className="gatekeeper">
      <Stack size="lg">
        <div className="gatekeeper__logo">
          <img src={logo} alt="krasserstoff.com" />
        </div>
        <Card className="gatekeeper__card" elevation={1} size="large">
          {children}
        </Card>
      </Stack>
    </div>
  );
}
